<ion-searchbar
  #searchWithin
  class='oval-ion-search'
  mode='md'
  placeholder='{{ placeholder }}'
  [ngClass]="{ 'square-ion-search': type === searchEnum.square}"
  (change)='search(searchWithin)'
  (ionClear)='resetSearchWithin()'
  [ngModel]='searchWithinText'
>
</ion-searchbar>
